module.exports = __webpack_public_path__ + "static/media/img155.dc1fd7f5.jpg";